<template>
  <v-container>
    <v-card>
      <v-card-title class="display-1">Air Transportation Schedule</v-card-title>
      <v-card-text>
        <v-alert text type="success" class="title"
          >Thanks for scheduling your flight information!</v-alert
        >
        <p class="title">
          Please go back and check the schedule and verify that we have the
          right arrival/departure dates &amp; times.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn large color="secondary" @click="goHome">
          <v-icon class="mr-1">mdi-undo</v-icon>Check Schedule
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="hasMessage" :color="messageType" multi-line>
      {{ message }}
      <v-btn text icon @click="hasMessage = false"
        ><v-icon>mdi-close</v-icon></v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'Thanks',
  data() {
    return {
      hasMessage: false,
      message: null,
      messageType: 'error',
      loading: false
    }
  },
  created() {},
  methods: {
    goHome() {
      this.$router.replace({ name: 'Home' })
    }
  }
}
</script>
